<template>
	<div class="header">
		<div class="container v-row">
			<div class="logo-box v-row">
				<img class="logo logo-default" src="../../../assets/images/logo.png" />
			</div>
			<div class="right-box">
				<div class="front-btn v-row v-row-align-center v-mr-20" @click="toIndex">
					<div class="iconfont icon-home v-mr-5"></div>
					<div class="label">首页</div>
				</div>
				<el-dropdown class="user-info" @command="handleCommand">
					<span class="el-dropdown-link">{{ userName }}<i class="el-icon-arrow-down el-icon--right"></i></span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="pwd">修改密码</el-dropdown-item>
						<el-dropdown-item command="logout">注销登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		<password v-if="isShowPwd" :show.sync="isShowPwd"></password>
	</div>
</template>

<script>
	import password from "./password";

	export default {
		components: {password},

		data() {

			return {
				isShowPwd: false,
				config: this.config
			};
		},

		computed: {
			userName() {
				let userInfo = this.$store.getters.userInfo;
				let companyName = userInfo.subjectInfo ? userInfo.subjectInfo.name + '-' : ''
				return companyName + userInfo.nickname
			}
		},

		methods: {
			handleCommand(command) {
				if (command === "pwd") {
					this.isShowPwd = true;
				}
				if (command === "logout") {
					this.logout();
				}
			},

			//退出登录
			async logout() {
				try {
					await this.$confirm("确认退出登录么?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					});
					this.$store.dispatch("user/logout");
				} catch (e) {
					console.error(e);
				}
			},

			toIndex() {
				let url = location.origin + '/index';
				let subjectInfo = this.$store.state.user.userInfo.subjectInfo;
				if (subjectInfo) {
					url += '/' + subjectInfo.id;
				}
				window.open(url, "_blank");
			}
		}
	};
</script>

<style lang="scss" scoped>
	.header {
		background: #001236;
		height: 64px;
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 16px;
	}

	.container {
		min-width: 1200px;
    max-width: 1400px;
    width: 100%;
		margin: 0 auto;
		justify-content: space-between;
	}

	.logo-box {
		display: flex;
		align-items: center;
		color: #fff;
		width: 190px;
		justify-content: center;

		.logo {
			margin-right: 14px;
			display: block;
			height: 50px;
		}
	}

	.right-box {
		display: flex;
		align-items: center;
		color: #fff;
	}

	.user-info {
		color: #fff;
		cursor: pointer;
	}

	.front-btn {
		margin-right: 30px;
		font-size: 13px;
		text-decoration: none;
		color: #fff;
		cursor: pointer;
	}

	.front-btn .iconfont {
		font-size: 14px;
		cursor: pointer;
	}
</style>
